




































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useFormat } from 'vivat';

import vehicles from '@/table/deliveryNote/vehicle';
import useAuth from '@/useAuth';

import VehicleObject from '@/components/DeliveryNote/VehicleObject.vue';

import getVehicles from '@/gql/vehicle/getVehiclesForSelectModal.gql';

const NOW = useFormat.date().computerShortDate();

const CommonModalWithVehicleSelector = defineComponent({
  components: {
    VehicleObject,
  },
  props: {
    filterDate: {},
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const modal = ref(null);
    function open() { (modal.value as any).open(); }
    function close() { (modal.value as any).close(); }
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const filterVehicleDisplay = ['ลำดับการสร้าง', 'แก้ไขข้อมูลล่าสุด', 'ชื่อ'];
    const filterVehicleList = ['createdAt', 'updatedAt', 'name'];
    const selectedFilterVehicle = ref('createdAt');

    const search = reactive({
      driverName: '',
      driverSearchInput: '',
    });

    const driverNameSearchHandler = (searchText: string) => {
      search.driverName = searchText;
    };

    const vehiclesVariable = computed(() => {
      const vars: {[key: string]: any} = {
        first: 6,
        searchName: undefined,
        filterFreeDate: props.filterDate ? props.filterDate : undefined,
      };
      return vars;
    });
    const getVehiclesResult = (data: any) => (data.vehicles);

    function getRecentMonthCashFlow(cashFlowArr: any[]) {
      for (let i = 0; i < cashFlowArr.length; i += 1) {
        if (cashFlowArr[i].month === (new Date()).getMonth() + 1) return cashFlowArr[i].sum;
      }
      return 0;
    }

    const selectedVehicle: Ref<any> = ref({
      id: -1,
      license: '',
      avatarUrl: '',
      minWeight: 0,
      maxWeight: 0,
      defaultDriver: undefined,
    });
    const selectVehicle = (row: any) => {
      selectedVehicle.value = { ...row.item };
    };
    const clearVehicle = () => {
      selectedVehicle.value.id = -1;
    };

    function confirmVehicle() {
      emit('selectVehicle', { ...selectedVehicle.value });
      close();
      clearVehicle();
    }

    return {
      me,
      modal,
      open,
      close,
      toCurrency,

      getVehicles,
      vehiclesVariable,
      getVehiclesResult,
      vehiclesOption: vehicles,

      selectedVehicle,
      selectVehicle,

      selectedFilterVehicle,
      search,
      driverNameSearchHandler,
      vehicles,

      confirmVehicle,
      clearVehicle,
    };
  },
});

export default CommonModalWithVehicleSelector;
